import React from "react";

const Queue = () => {
    return <p>Queue is to do</p>
};

export default Queue;
// TODO